import { styled, Chip, chipClasses } from '@mui/material';

export const OrderActiveFiltersChip = styled(Chip)(({ theme }) => ({
  [`& .${chipClasses.label}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
}));
